// deps
import { useCallback } from "react";

// internal-deps
import { format } from "@swiggy-private/js-utils";
import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { MARKETPLACE_BUSINESS_LINE, MARKETPLACE_CATEGORY } from "@swiggy-private/payment-types";
import { isWebPlatform } from "@swiggy-private/core-ui";

// helpers
import { navigateToLink } from "@dineout-payment-success-ui/helpers/nativeBridge";
import { DOWNSTREAM_HOSTS } from "@dineout-payment-success-ui/utils/Hosts";

// constants
import {
    PAYMENT_WEBVIEW_URL,
    SCENES_FULL_PAYMENT_REDIR_URL,
    SCENES_FULL_PAYMENT_REDIR_WEB_URL,
    X_WEB_CHECKOUT_FLOW_DINEOUT_CART,
} from "@dineout-payment-success-ui/constants";

export const usePartialPaymentCtaClick = (bookingId?: string) => {
    const handlePaymentCtaClick = useCallback(() => {
        if (!bookingId) {
            return;
        }

        const platform = GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform) || "";
        const isWeb = isWebPlatform(platform);

        const paymentUrl = format(SCENES_FULL_PAYMENT_REDIR_URL, DOWNSTREAM_HOSTS.CHECKOUT_WEB_APP_HOST, bookingId);
        const webPaymentUrl = format(
            SCENES_FULL_PAYMENT_REDIR_WEB_URL,
            DOWNSTREAM_HOSTS.CHECKOUT_WEB_APP_HOST,
            bookingId,
        );

        const targetUrl = isWeb ? webPaymentUrl : paymentUrl;
        const encodedPaymentUrl = encodeURIComponent(targetUrl);
        const deeplink = format(PAYMENT_WEBVIEW_URL, encodedPaymentUrl);
        const httpHeaders = {
            marketplaceBusinessLine: MARKETPLACE_BUSINESS_LINE.DINEOUT,
            marketplaceCategory: MARKETPLACE_CATEGORY.DINING,
            [SwgyHeaderKeysList.xWebCheckoutFlow]: X_WEB_CHECKOUT_FLOW_DINEOUT_CART,
            [SwgyHeaderKeysList.serviceLine]: MARKETPLACE_BUSINESS_LINE.DINEOUT,
            showsuccessscreen: "true",
        };
        navigateToLink(deeplink, false, false, httpHeaders);
    }, [bookingId]);

    return handlePaymentCtaClick;
};
